;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();import React, { useRef, useState } from "react"
import SearchFilterButton from "../shared/SearchFilterButton"
import ClearFilterButton from "../shared/ClearFilterButton"
import {
  SEARCH_FILTERS,
  SEARCH_FILTER_WORKSHOP,
  SEARCH_FILTER_THERAPY_GROUP,
  SEARCH_FILTER_SUPPORT_GROUP,
  SEARCH_FILTER_RETREATS,
  SEARCH_FILTER_THERAPISTS,
  SEARCH_FILTER_COACHES,
  SEARCH_FILTER_ALTERNATIVE,
  SEARCH_FILTER_IN_PERSON,
  SEARCH_FILTER_VIRTUAL,
  SEARCH_FILTER_PROVIDER_GROUP,
} from "../../../../lib/constants"

function SearchFilters({
  filters = SEARCH_FILTERS,
  groupTypes,
  providerTypes,
  virtual,
  inPerson,
  isTherapyGroups,
  isSupportGroups,
  isRetreats,
  isWorkshops,
  isProviderGroups,
  isCoaches,
  isTherapists,
  isAlternative,
  handleUpdateSearch,
  areQueryParamsPresent,
  isPending = false,
}) {
  const filtersRef = useRef(null)
  const [isDown, setIsDown] = useState(false)
  const [startX, setStartX] = useState(0)
  const [scrollLeft, setScrollLeft] = useState(0)
  const [clearFiltersSelectedHomePage, setClearFiltersSelectedHomePage] =
    useState(areQueryParamsPresent)

  const isAnyFilterActive =
    virtual ||
    inPerson ||
    (groupTypes && groupTypes.length) ||
    (providerTypes && providerTypes.length) // Added this line to check if any filter is active

  const handleMouseDown = (e) => {
    setIsDown(true)
    setStartX(e.pageX - filtersRef.current.offsetLeft)
    setScrollLeft(filtersRef.current.scrollLeft)
  }

  const handleMouseMove = (e) => {
    if (!isDown) return
    e.preventDefault()
    const x = e.pageX - filtersRef.current.offsetLeft
    const walk = x - startX
    filtersRef.current.scrollLeft = scrollLeft - walk
  }

  const toggleFilter = (filterType) => {
    // if we are on homne page and user has previously selected clear filters,
    if (!areQueryParamsPresent && clearFiltersSelectedHomePage) {
      console.log("toggleFilter", filterType)
      if (filterType === SEARCH_FILTER_IN_PERSON.type) {
        // if they touch in-person than they expect this filter to be the only one selected
        handleUpdateSearch({
          newInPerson: true,
          newVirtual: false,
        })
        return
      } else if (filterType === SEARCH_FILTER_VIRTUAL.type) {
        // if they touch in-person than they expect this filter to be the only one selected
        handleUpdateSearch({
          newInPerson: false,
          newVirtual: true,
        })
        return
      }
    }

    // Update groupTypes and providerTypes arrays
    let newGroupTypes = groupTypes ? [...groupTypes] : []
    let newProviderTypes = providerTypes ? [...providerTypes] : []

    if (
      [
        SEARCH_FILTER_THERAPY_GROUP.type,
        SEARCH_FILTER_WORKSHOP.type,
        SEARCH_FILTER_SUPPORT_GROUP.type,
        SEARCH_FILTER_RETREATS.type,
        SEARCH_FILTER_PROVIDER_GROUP.type,
      ].includes(filterType)
    ) {
      newGroupTypes = groupTypes.includes(filterType)
        ? groupTypes.filter((item) => item !== filterType)
        : [...groupTypes, filterType]
    }

    if (
      [
        SEARCH_FILTER_THERAPISTS.type,
        SEARCH_FILTER_COACHES.type,
        SEARCH_FILTER_ALTERNATIVE.type,
      ].includes(filterType)
    ) {
      newProviderTypes = providerTypes.includes(filterType)
        ? providerTypes.filter((item) => item !== filterType)
        : [...providerTypes, filterType]
    }

    // Call handleUpdateSearch with the updated filter values
    handleUpdateSearch({
      newGroupTypes,
      newProviderTypes,
      newVirtual: filterType === SEARCH_FILTER_VIRTUAL.type ? !virtual : virtual,
      newInPerson:
        filterType === SEARCH_FILTER_IN_PERSON.type ? !inPerson : inPerson,
    })
  }

  // Added this function to clear filters
  const clearFilters = () => {
    // if we are on the home page, simply update state of clear filters selected
    if (!areQueryParamsPresent) {
      setClearFiltersSelectedHomePage(!clearFiltersSelectedHomePage)
    } else {
      handleUpdateSearch({
        newGroupTypes: [],
        newProviderTypes: [],
        newVirtual: false,
        newInPerson: false,
      })
    }
  }
  const renderGradient = () => {
    return (
      <div className="block min-[1120px]:hidden absolute top-0 right-0 w-12 h-full bg-linear-to-r from-transparent to-white pointer-events-none"></div>
    )
  }

  const renderClearFilterButton = () => {
    // if home page and someone clicks clear filters. it should look like no filters are selected
    if (!areQueryParamsPresent && clearFiltersSelectedHomePage) {
      return null
    }
    // Only show if at least one filter is active
    if (isAnyFilterActive) {
      return <ClearFilterButton onClick={clearFilters} />
    }
    return null // Or render nothing
  }

  const isFilterActive = (filterType) => {
    switch (filterType) {
      case SEARCH_FILTER_VIRTUAL.type:
        if (!areQueryParamsPresent && clearFiltersSelectedHomePage) {
          // on the home page, and clear filters selected
          return false
        } else {
          return virtual
        }
      case SEARCH_FILTER_IN_PERSON.type:
        if (!areQueryParamsPresent && clearFiltersSelectedHomePage) {
          // on the home page, and clear filters selected
          return false
        } else {
          return inPerson
        }
      case SEARCH_FILTER_WORKSHOP.type:
        return isWorkshops
      case SEARCH_FILTER_THERAPY_GROUP.type:
        return isTherapyGroups
      case SEARCH_FILTER_SUPPORT_GROUP.type:
        return isSupportGroups
      case SEARCH_FILTER_RETREATS.type:
        return isRetreats
      case SEARCH_FILTER_PROVIDER_GROUP.type:
        return isProviderGroups
      case SEARCH_FILTER_THERAPISTS.type:
        return isTherapists
      case SEARCH_FILTER_COACHES.type:
        return isCoaches
      case SEARCH_FILTER_ALTERNATIVE.type:
        return isAlternative
      default:
        return false
    }
  }

  const renderSearchFiltersButton = () => {
    return filters.map(({ type }, index) => {
      return (
        <SearchFilterButton
          searchFilterType={type}
          isActive={isFilterActive(type)} // Added to pass active state to child
          onClick={() => toggleFilter(type)} // Added to toggle filter
          key={"search-filter-button-" + index}
        />
      )
    })
  }

  // A tab with no filters (organizations) renders no row at all.
  if (!filters.length) {
    return null
  }

  return (
    <div
      className={`relative overflow-hidden w-full min-[1120px]:flex min-[1120px]:justify-center ${
        isPending ? "pointer-events-none opacity-70" : ""
      }`}
      key="search-filters-comp"
    >
      <div
        className={`flex items-center overflow-x-auto whitespace-nowrap space-x-2 min-w-[800px]:space-x-4 px-[10px] -mb-2 py-[10px] overflow-auto cursor-grab active:cursor-grabbing min-w-[1120px]:px-auto`} //[-webkit-overflow-scrolling:touch]
        ref={filtersRef}
        onMouseDown={handleMouseDown}
        onMouseLeave={() => setIsDown(false)}
        onMouseUp={() => setIsDown(false)}
        onMouseMove={handleMouseMove}
      >
        {renderClearFilterButton()}
        {renderSearchFiltersButton()}
      </div>
      {renderGradient()}
    </div>
  )
}

export default SearchFilters
